/**
 * Formats a count with a noun that agrees in number, e.g. `pluralize(1, "error")`
 * -> "1 error" and `pluralize(3, "error")` -> "3 errors". The plural form defaults
 * to the singular plus "s"; pass `plural` explicitly for irregular nouns.
 */
export function pluralize(
  count: number,
  singular: string,
  plural: string = `${singular}s`
): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
